module.exports = __webpack_public_path__ + "img/camera-video-off.1f4cad04.svg";